import { AccountingDelegate } from './accounting.delegate';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { AccountingService } from './accounting.service';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { HttpProviderFactory } from '../http/http-provider.factory';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class AccountingServiceFactory
{
    static create(config: IAppConfig,
        spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService): AccountingService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new AccountingDelegate(config, httpProvider);
        return new AccountingService(delegate, authenticationService);
    }
}